module.exports = __webpack_public_path__ + "img/experience.2f6b0bd2.png";